export type RouteMatchLike = { handle?: unknown }

export function hasWorkspaceLayout(matches: RouteMatchLike[]): boolean {
  return matches.some((match) => {
    if (!match.handle || typeof match.handle !== 'object') return false
    return (match.handle as { layout?: unknown }).layout === 'workspace'
  })
}
